import urlAliasSchema from './url-alias/schema.json';
import urlPatternSchema from './url-pattern/schema.json';

export default {
  'url-alias': {
    schema: urlAliasSchema,
  },
  'url-pattern': {
    schema: urlPatternSchema,
  },
};
